// const baseUrl = `https://gifview-hasura.hasura.app/v1`;
const baseUrl = `https://api.gifview.com`;
// const baseUrl = `http://localhost:9090`;

const endpoint = `${baseUrl}/graphql`;

/** Better Upload presign endpoint (same host as `baseUrl`). */
const uploadApiUrl = `${baseUrl}/api/upload`;

export { baseUrl, endpoint, uploadApiUrl };
